// Kennlinien für das Tagesdiagramm im Bericht (T-0159).

/**
 * Gleitender Schnitt über ``fenster`` Tage. Erst ab dem ``fenster``-ten Tag gibt
 * es einen Wert — ein Schnitt über zwei Tage wäre kein 7-Tage-Schnitt.
 */
export function gleitenderSchnitt(werte: readonly number[], fenster = 7): Array<number | null> {
  let summe = 0;
  return werte.map((wert, i) => {
    summe += wert;
    if (i >= fenster) summe -= werte[i - fenster];
    return i >= fenster - 1 ? Math.round((summe / fenster) * 100) / 100 : null;
  });
}

/** Durchschnitt pro Tag, auf zwei Stellen gerundet; 0 ohne Tage. */
export function durchschnitt(werte: readonly number[]): number {
  if (werte.length === 0) return 0;
  return Math.round((werte.reduce((a, b) => a + b, 0) / werte.length) * 100) / 100;
}

/**
 * Die Vorperiode Tag für Tag neben die aktuelle legen: Tag 1 neben Tag 1.
 * Fehlt ein Tag (kürzere Vorperiode), steht dort ``null``.
 */
export function vorperiodeJeTag(aktuell: number, vorher: readonly { total: number }[]): Array<number | null> {
  return Array.from({ length: aktuell }, (_, i) => (i < vorher.length ? vorher[i].total : null));
}

/** Veränderung gegenüber der Vorperiode in Prozent; ``null`` ohne Vergleichswert. */
export function veraenderung(jetzt: number, vorher: number): number | null {
  if (vorher <= 0) return null;
  return Math.round(((jetzt - vorher) / vorher) * 100);
}
